import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Feed from "@/pages/Feed";
import Dashboard from "@/pages/Dashboard";
import Onboarding from "@/pages/Onboarding";
import CreatorPublic from "@/pages/CreatorPublic";
import Admin from "@/pages/Admin";
import Subscriptions from "@/pages/Subscriptions";
import Leaderboard from "@/pages/Leaderboard";
import FanProfile from "@/pages/FanProfile";
import Messages from "@/pages/Messages";
import Support from "@/pages/Support";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Settings from "@/pages/Settings";
import IntroSplash from "@/components/IntroSplash";

function App() {
  return (
    <div className="App min-h-screen bg-[#0D0D0D]">
      <IntroSplash />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/recupero-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/creator/:id" element={<CreatorPublic />} />
            <Route path="/supporto" element={<Support />} />
            <Route path="/feed" element={<ProtectedRoute><Feed /></ProtectedRoute>} />
            <Route path="/classifica" element={<ProtectedRoute><Leaderboard /></ProtectedRoute>} />
            <Route path="/subscriptions" element={<ProtectedRoute><Subscriptions /></ProtectedRoute>} />
            <Route path="/profilo" element={<ProtectedRoute role="fan"><FanProfile /></ProtectedRoute>} />
            <Route path="/messaggi" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
            <Route path="/impostazioni" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute role="creator"><Dashboard /></ProtectedRoute>} />
            <Route path="/onboarding" element={<ProtectedRoute role="creator"><Onboarding /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute role="admin"><Admin /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-center" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
